<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Tipologia" v-model="element.type" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <div class="field">
        <label class="label">Installato in U.T.A. o V.M.C.</label>
        <div class="control is-flex">
          <label class="checkbox">
            <input type="checkbox" v-model="element.installed">
          </label>
        </div>
      </div>
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <div class="field">
        <label class="label">Indipendente</label>
        <div class="control is-flex">
          <label class="checkbox">
            <input type="checkbox" v-model="element.independent">
          </label>
        </div>
      </div>
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Portata ventilatore di mandata (l/s)" v-model="element.flow_output" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Potenza ventilatore di mandata (kW)" v-model="element.power_output" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Portata ventilatore di ripresa (l/s)" v-model="element.flow_input" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Potenza ventilatore di ripresa (kW)" v-model="element.power_input" />
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputTextarea name="Note" v-model="element.notes" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>